import * as React from "react"

const Moon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={1080}
    height={1080}
    xmlSpace="preserve"
    viewBox="109.843 109.541 1080 1080"
    className="moonSVG"
    {...props}
  >
    <defs>
      <path id="a" d="M0 0h1080v1080H0z" />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <g clipPath="url(#b)">
      <defs>
        <path id="c" d="M0 0h1080v1080H0z" />
      </defs>
      <clipPath id="d">
        <use xlinkHref="#c" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M918.697 524.669c0 216.655-175.614 392.27-392.269 392.27-112.202 0-213.484-47.118-284.998-122.596-66.493-70.28-107.27-165.222-107.27-269.674 0-9.776.352-19.552 1.056-29.152.705-9.071 1.674-17.966 2.994-26.861 9.072-64.116 33.732-123.212 70.017-173.324 3.963-5.637 8.191-11.185 12.594-16.646 48.616-60.329 114.757-105.949 190.675-129.2a296.062 296.062 0 0 1 19.727-5.373h.089c12.77-3.17 25.716-5.812 38.927-7.662a347.005 347.005 0 0 1 27.214-2.906c9.6-.793 19.2-1.145 28.975-1.145 126.999 0 239.994 60.329 311.596 153.949 50.641 66.053 80.673 148.664 80.673 238.32"
      />
      <path
        clipPath="url(#d)"
        fill="#9097E1"
        d="M612.536 543.875a1.177 1.177 0 1 1-2.353-.001 1.177 1.177 0 0 1 2.353.001"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="m609.352 542.352 1.326.929M611.7 541.938l-.157 1.03M612.021 543.751h2.634M608.744 546.541l1.841-2.403M612.068 545.417l-.368-.699"
      />
      <path
        clipPath="url(#d)"
        fill="#C5D3EF"
        d="M918.697 524.669c0 216.655-175.614 392.27-392.269 392.27-112.202 0-213.484-47.118-284.998-122.596-51.169-66.229-81.642-149.368-81.642-239.554 0-85.605 27.39-164.869 74.068-229.337 3.963-5.637 8.191-11.185 12.594-16.645 6.341-7.927 13.035-15.589 19.992-22.987 2.554-2.642 5.108-5.284 7.75-7.838.881-1.057 1.85-1.938 2.731-2.819 2.378-2.377 4.843-4.755 7.398-7.045 2.378-2.29 4.844-4.492 7.31-6.606.704-.792 1.497-1.409 2.289-2.113.265-.265.529-.441.793-.617 2.026-1.761 3.963-3.435 5.989-5.108a115.126 115.126 0 0 1 3.787-3.082c2.29-1.938 4.58-3.787 6.958-5.549 4.491-3.523 9.159-6.957 13.827-10.304.264-.176.616-.44.881-.617a200.544 200.544 0 0 1 10.04-6.869 91.143 91.143 0 0 1 6.164-3.963 394.99 394.99 0 0 1 13.035-7.927c4.58-2.73 9.248-5.284 14.003-7.75 3.787-2.026 7.662-3.963 11.538-5.901 9.952-4.844 20.256-9.335 30.649-13.299a366.982 366.982 0 0 1 10.48-3.875c.793-.264 1.674-.528 2.466-.793 4.14-1.497 8.367-2.818 12.594-4.139a296.085 296.085 0 0 1 19.728-5.372h.088c30.473-7.662 62.354-11.714 95.117-11.714 112.818 0 214.541 47.647 285.967 123.829 50.641 66.053 80.673 148.664 80.673 238.32"
      />
      <path
        clipPath="url(#d)"
        fill="#ADBFEA"
        d="M899.956 554.802c0 189.905-153.933 343.838-343.839 343.838-98.35 0-187.127-41.3-249.812-107.459-58.284-61.604-94.027-144.823-94.027-236.379 0-75.036 24.008-144.514 64.923-201.023 3.474-4.941 7.179-9.804 11.039-14.59 42.614-52.881 100.589-92.869 167.134-113.249a259.211 259.211 0 0 1 17.292-4.71h.077c26.71-6.716 54.656-10.267 83.374-10.267 111.318 0 210.363 52.881 273.126 134.942 44.389 57.897 70.713 130.309 70.713 208.897"
      />
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M659.84 444.889c-4.051 23.515 6.782 27.038.528 49.408-1.938 6.781-7.574 26.069-24.925 35.757-8.014 4.492-16.381 5.725-25.012 5.636-53.547-.528-76.005-45.356-111.41-42.538-22.898 1.85-29.768 13.739-55.749 10.305-15.5-2.026-40.425-10.041-45.357-26.95-3.346-11.449 3.699-22.458 2.29-22.987-1.585-.616-6.869 14.884-15.94 26.597-14.268 18.319-41.218 31.266-69.665 29.152-28.271-2.114-53.107-18.583-66.053-41.393-13.475-23.691-10.305-47.735-9.16-56.278 1.057-7.926 2.907-21.137 12.066-35.052 3.171-4.756 16.822-25.629 39.632-29.856 11.273-2.114 14.708 1.849 22.37-2.29 11.625-6.341 19.904-23.427 14.356-34.435-4.228-8.456-15.06-10.657-22.987-12.067-23.163-4.315-44.387 3.523-58.391 10.921 14.356-17.878 30.208-34.347 47.47-49.408 5.725-4.932 11.538-9.776 17.527-14.355 37.166-28.976 79.616-51.346 125.677-65.437 7.662 1.145 15.413 2.554 23.427 4.491 38.311 9.16 96.614 22.987 112.027 65.525 6.252 17.351 12.771 60.153-5.813 91.859-3.611 6.253-10.216 15.5-8.016 26.421 2.467 12.242 15.148 22.282 28.184 24.748 14.003 2.642 25.188-4.139 26.422-4.844 16.645-10.304 12.064-26.773 27.565-35.405 9.247-5.196 22.635-5.812 31.002.617 9.6 7.31 9.334 21.577 9.158 29.856-.614 28.271-16.292 33.467-21.223 62.002"
      />
      <path
        clipPath="url(#d)"
        fill="#C9E7FF"
        d="M677.294 346.061c-11.889-9.159-29.504-7.662-40.688-1.321-10.216 5.637-14.003 14.18-16.997 21.05-2.731 5.988-4.844 10.744-10.745 14.443-2.995 1.761-10.921 5.548-20.257 3.787-10.304-1.937-19.639-9.776-21.226-17.878-1.32-6.341 2.379-12.506 5.638-17.967l1.321-2.201c19.198-32.851 14.443-77.415 6.517-99.345-16.998-46.854-77.767-61.385-118.191-71.073-1.85-.441-3.787-.881-5.725-1.321h-.088a296.085 296.085 0 0 0-19.728 5.372c-4.227 1.321-8.455 2.642-12.594 4.139-.793.265-1.674.529-2.466.793a366.982 366.982 0 0 0-10.48 3.875c-10.393 3.963-20.698 8.455-30.65 13.299-3.875 1.937-7.75 3.875-11.537 5.901-4.756 2.466-9.424 5.02-14.003 7.75a394.99 394.99 0 0 0-13.035 7.927 91.128 91.128 0 0 0-6.164 3.962 201.728 201.728 0 0 0-10.041 6.87c-.264.176-.616.44-.881.617-4.667 3.346-9.335 6.781-13.826 10.304-2.378 1.761-4.668 3.611-6.958 5.548a116.479 116.479 0 0 0-3.787 3.083 302.108 302.108 0 0 0-5.989 5.108c-.265.176-.529.352-.793.616-.792.705-1.585 1.322-2.289 2.114-2.467 2.114-4.932 4.315-7.31 6.605-2.555 2.29-5.021 4.668-7.399 7.046-.88.881-1.849 1.762-2.73 2.818-2.642 2.555-5.196 5.197-7.75 7.839-6.958 7.398-13.651 15.06-19.992 22.986-4.403 5.461-8.631 11.009-12.594 16.646l16.733-8.895c12.682-6.694 32.058-13.828 52.667-10.041 6.958 1.233 14.443 2.907 16.733 7.399 2.995 6.076-2.73 18.406-10.744 22.722-1.938 1.057-2.818 1.057-6.077.792-3.259-.264-7.575-.528-13.652.617-11.977 2.202-29.503 9.776-45.444 33.643-10.304 15.765-12.33 30.737-13.387 38.752-1.145 8.719-4.756 35.404 10.217 61.737 14.795 26.069 42.802 43.684 73.098 45.885 29.769 2.114 60.153-10.656 77.239-32.586.176-.264.44-.528.616-.792 8.72 16.469 31.706 25.012 50.289 27.478 17.262 2.29 27.39-1.41 37.166-5.108 6.253-2.29 12.154-4.492 20.432-5.109 13.475-1.057 25.717 6.958 39.897 16.294 17.614 11.537 39.544 25.98 70.721 26.245h.881c11.186 0 20.256-2.114 28.535-6.782 13.827-7.75 23.603-21.489 29.063-41.041 3.875-13.827 2.113-22.106.527-29.504-.88-3.875-1.585-7.486-1.585-12.066 0-2.465.177-5.372.793-8.719 2.026-11.625 5.901-18.759 10.128-26.245 5.285-9.6 10.833-19.552 11.186-37.078.175-9.424.528-26.95-12.595-36.99m-376.416-81.114a318.571 318.571 0 0 1 14.796-12.154c36.285-28.535 77.502-50.289 122.155-64.204 7.485 1.233 14.267 2.554 21.049 4.14 36.461 8.718 91.681 21.929 105.421 59.888 6.517 18.142 10.92 57.07-5.196 84.46l-1.146 2.026c-4.228 6.957-10.48 17.438-7.839 30.561 2.995 15.06 17.791 28.358 35.142 31.617 15.235 2.906 27.741-3.082 32.762-5.989 10.657-6.605 14.532-15.412 17.702-22.37 2.818-6.429 4.58-10.128 9.512-12.858 6.87-3.787 16.381-3.875 21.313 0 6.076 4.58 5.9 15.852 5.725 22.634-.264 13.123-4.139 20.08-8.983 28.887-4.491 8.103-9.6 17.262-12.153 31.794-2.202 12.858-.441 21.049.969 27.567 1.497 6.605 2.466 11.361-.177 20.961-1.585 5.548-6.253 22.369-20.784 30.472-5.726 3.17-12.242 4.668-20.609 4.492-26.068-.265-43.946-11.978-61.21-23.427-15.059-9.865-29.415-19.288-46.941-19.288-1.321 0-2.73.088-4.052.176-10.744.881-18.407 3.699-25.188 6.253-8.807 3.259-15.677 5.813-28.711 4.139-16.558-2.201-34.876-10.039-38.047-20.696-1.497-5.108.352-10.657 1.585-14.268.793-2.466 1.145-4.58 1.145-6.341-.088-4.756-2.994-6.957-5.636-8.102-5.989-2.379-9.6 1.056-12.33 5.548-1.145 1.673-2.114 3.611-2.995 5.372-2.642 5.285-6.252 12.507-10.832 18.407-13.299 17.174-38.312 27.567-62.09 25.805-24.484-1.761-47.031-15.941-59.008-36.902-12.066-21.225-9.159-42.714-8.103-50.817.969-7.045 2.554-18.935 10.833-31.529 12.33-18.495 25.1-24.308 33.731-25.893 3.876-.705 6.429-.528 9.16-.353 4.139.353 9.247.705 15.852-2.818 14.973-8.19 26.07-30.12 17.967-46.149-6.341-12.682-21.225-15.324-29.239-16.733-9.953-1.938-20.521-1.85-31.178.088 8.19-8.543 16.733-16.734 25.628-24.396"
      />
      <path
        clipPath="url(#d)"
        fill="#6682C2"
        d="M315.746 253.951c0 6.341-5.284 11.537-11.625 11.537a10.09 10.09 0 0 1-3.259-.528c-2.994-.792-5.549-2.818-6.957-5.549 5.724-4.932 11.537-9.775 17.526-14.355 2.378 1.761 3.963 4.58 4.227 7.75.088.353.088.793.088 1.145M369.197 428.313c0 28.708-23.273 51.981-51.981 51.981-28.709 0-51.981-23.273-51.981-51.981s23.272-51.981 51.981-51.981c28.708.001 51.981 23.273 51.981 51.981M637.208 480.294c0 16.949-13.74 30.689-30.689 30.689s-30.689-13.74-30.689-30.689c0-16.949 13.74-30.689 30.689-30.689s30.689 13.741 30.689 30.689M662.399 376.333a7.53 7.53 0 1 1-15.06 0 7.53 7.53 0 0 1 15.06 0M556.999 468.929c0 6.413-5.198 11.611-11.611 11.611s-11.611-5.198-11.611-11.611 5.198-11.611 11.611-11.611 11.611 5.198 11.611 11.611"
      />
      <path
        clipPath="url(#d)"
        fill="#6682C2"
        d="M607.975 453.396c0 6.413-5.198 11.611-11.611 11.611s-11.61-5.198-11.61-11.611 5.197-11.611 11.61-11.611 11.611 5.198 11.611 11.611"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={17.614}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="m485.652 407.205 17.231 7.323M534.475 334.116l10.913-4.451M480.483 321.91l3.877-3.303"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={14.972}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M426.061 283.283v24.555"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={17.614}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M432.522 432.837v8.616"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={14.972}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="m359.864 350.126 6.462 2.585"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={17.614}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="m357.495 445.976 17.446-17.663"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#9097E1"
        strokeWidth={14.972}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="m349.74 409.79 5.6-2.585"
      />
      <g opacity={0.51} clipPath="url(#d)">
        <defs>
          <path id="e" d="M481.32 229.261h15.581v15.722H481.32z" />
        </defs>
        <clipPath id="f">
          <use xlinkHref="#e" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#f)"
          fill="#6682C2"
          d="M492.056 244.983a4.827 4.827 0 0 1-3.466-1.458l-5.892-6.033a4.844 4.844 0 0 1 .082-6.851c1.91-1.875 4.984-1.832 6.851.082l5.891 6.033a4.844 4.844 0 0 1-3.466 8.227"
        />
      </g>
      <g opacity={0.51} clipPath="url(#d)">
        <defs>
          <path id="g" d="M346.868 246.908h15.126v10.658h-15.126z" />
        </defs>
        <clipPath id="h">
          <use xlinkHref="#g" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#h)"
          fill="#6682C2"
          d="M351.709 257.566a4.847 4.847 0 0 1-.847-9.616l5.436-.971c2.7-.448 5.147 1.285 5.62 3.917a4.846 4.846 0 0 1-3.918 5.621l-5.435.972a4.926 4.926 0 0 1-.856.077"
        />
      </g>
      <g opacity={0.51} clipPath="url(#d)">
        <defs>
          <path id="i" d="M400.834 220.833h13.693v13.472h-13.693z" />
        </defs>
        <clipPath id="j">
          <use xlinkHref="#i" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#j)"
          fill="#6682C2"
          d="M405.678 234.306a4.836 4.836 0 0 1-3.522-1.514 4.849 4.849 0 0 1 .194-6.85l4.003-3.784a4.845 4.845 0 1 1 6.657 7.044l-4.004 3.784a4.843 4.843 0 0 1-3.328 1.32"
        />
      </g>
      <g opacity={0.51} clipPath="url(#d)">
        <defs>
          <path id="k" d="M351.607 221.708h79.294v64.409h-79.294z" />
        </defs>
        <clipPath id="l">
          <use xlinkHref="#k" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#l)"
          fill="#6682C2"
          d="M424.833 242.564h-23.998c-1.422 0-2.735-.658-3.681-1.719l-.152-.167c-1.046-1.133-1.609-2.628-1.378-4.153l1.243-8.204a5.735 5.735 0 0 0-4.821-6.537c-3.126-.517-6.066 1.678-6.538 4.82l-.887 5.859c-.445 2.938-3.823 4.383-6.255 2.677l-10.86-7.615c-2.774-1.955-6.649-1.089-8.336 1.933-1.457 2.61-.461 5.931 1.986 7.647l13.278 9.312-.566 2.804c-.012.015-.031.022-.043.038l-20.952 27.342c-1.932 2.52-1.659 6.425.871 8.343a5.74 5.74 0 0 0 3.476 1.173 5.744 5.744 0 0 0 4.568-2.25l14.959-19.522c1.471-1.92 4.018-2.789 6.291-1.961.347.127.701.239 1.063.335 1.641.439 3.081 1.427 3.873 2.93l2.366 4.491a5.746 5.746 0 0 0 8.241 2.126c2.53-1.651 3.181-5.101 1.773-7.774l-1.783-3.384c-.756-1.434-.616-3.124.204-4.523l.05-.085c.841-1.46 2.309-2.443 3.994-2.443h22.337a5.745 5.745 0 0 0 5.717-6.335c-.298-2.992-3.035-5.158-6.04-5.158"
        />
      </g>
      <path
        clipPath="url(#d)"
        fill="#C9E7FF"
        d="M517.621 340.777c-1.761-4.756-6.957-7.134-11.625-5.372l-41.482 16.029c-4.579 1.761-9.599 0-12.77-3.876 0-.088-.088-.176-.088-.176-3.083-3.787-3.787-9.071-1.321-13.211l24.924-42.714c2.554-4.315 1.145-9.952-3.17-12.594-4.316-2.643-9.864-1.145-12.419 3.17l-27.654 47.471c-5.636 9.688-19.904 7.574-22.634-3.347L402.952 300c-1.232-4.932-6.164-7.926-11.008-6.606-4.844 1.234-7.751 6.254-6.518 11.187l6.87 27.654-31.089-26.335c-3.875-3.258-9.512-2.73-12.771 1.234-3.17 3.875-2.642 9.688 1.233 12.946l33.379 28.271c3.435 2.994 4.58 7.75 3.259 12.154-.088.176-.176.44-.264.616-1.321 4.844-5.372 8.367-10.216 8.455l-54.692 1.057c-3.699.088-6.958 2.466-8.279 5.901-.44 1.056-.617 2.29-.617 3.523.088 4.932 4.052 8.895 8.896 8.983h.352l29.063-.529 26.598-.528-8.279 3.699c-4.579 1.937-6.694 7.398-4.756 12.066 1.409 3.434 4.756 5.548 8.191 5.636 1.233 0 2.466-.264 3.699-.792l20.08-8.807c.176-.089 2.818-.969 5.108.792 2.202 1.761 2.114 4.492 2.114 4.756l-12.154 45.533-1.761 6.429c-.969 3.787.352 7.574 3.17 9.688a6.897 6.897 0 0 0 3.083 1.585 4.887 4.887 0 0 0 1.497.264c.264.088.528.088.792.088 4.052.088 7.751-2.642 8.807-6.781l2.379-8.719 11.537-42.803c1.057-3.435 3.875-5.9 7.222-6.517 3.523-.705 7.045.705 9.159 3.611 6.077 7.31 12.066 14.62 18.055 21.842 1.761 2.201 4.227 3.258 6.781 3.346 2.114 0 4.228-.704 5.901-2.201 3.875-3.259 4.404-9.072 1.145-12.947l-17.35-21.137c3.435-4.316 6.077-9.248 7.486-14.796l44.388 2.642h.44c4.756.088 8.807-3.699 9.159-8.631.265-5.108-3.522-9.423-8.542-9.776l-23.251-1.409 31.177-11.978c4.668-1.849 6.958-7.134 5.196-11.889m-95.381 42.362c-5.989-.088-10.833-5.196-10.744-11.361.088-6.165 5.108-11.097 11.097-11.009 5.988.088 10.832 5.196 10.744 11.361-.088 6.077-5.02 11.009-11.097 11.009"
      />
      <g opacity={0.51} clipPath="url(#d)">
        <defs>
          <path id="m" d="M484.542 231.833h75.738v84.196h-75.738z" />
        </defs>
        <clipPath id="n">
          <use xlinkHref="#m" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#n)"
          fill="#6682C2"
          d="m557.87 291.545-19.288-10.393 7.839-1.232c2.466-.441 4.139-2.731 3.787-5.285-.44-2.466-2.819-4.139-5.285-3.699l-11.625 1.85c-2.554.704-5.284 0-7.046-1.85-2.466-2.554-1.937-5.813-1.937-6.165l1.057-28.271c.088-2.466-1.85-4.579-4.404-4.668-2.378.089-4.668 1.85-4.756 4.404l-.969 28.535c.265 1.673-.44 3.435-1.849 4.404-1.497.968-3.435.968-4.844 0l-17.086-10.393c-2.201-1.233-5.02-.616-6.253 1.585-1.321 2.114-.616 4.932 1.497 6.254l18.319 11.097c1.321.704 3.699 2.289 5.725 5.02 2.818 3.963 3.082 8.102 3.082 9.776-.792 6.077-1.585 12.242-2.378 18.318-.352 2.466 1.41 4.756 3.964 5.108.176 0 .352.088.528.088 2.29 0 4.227-1.673 4.58-3.963l1.849-14.003c.264-2.642 1.938-4.844 4.228-6.077.44-.264.792-.44 1.145-.705 2.73-1.761 6.077-2.289 8.983-.792l16.822 9.159a4.773 4.773 0 0 0 2.201.529c1.586 0 3.171-.881 3.964-2.378 1.232-2.29.352-5.02-1.85-6.253m-38.135-6.958a5.713 5.713 0 0 1-5.724-5.724c0-3.171 2.554-5.725 5.724-5.725s5.725 2.554 5.725 5.725a5.714 5.714 0 0 1-5.725 5.724"
        />
      </g>
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M643.024 748.825c0 14.868-12.053 26.92-26.92 26.92-14.868 0-26.921-12.052-26.921-26.92s12.053-26.92 26.921-26.92c14.868 0 26.92 12.052 26.92 26.92"
      />
      <circle
        clipPath="url(#d)"
        fill="none"
        stroke="#C9E7FF"
        strokeWidth={17.614}
        strokeLinecap="round"
        strokeMiterlimit={10}
        cx={616.104}
        cy={748.825}
        r={26.92}
      />
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M610.435 855.8c0 17.962-14.561 32.524-32.523 32.524-17.962 0-32.523-14.563-32.523-32.524s14.562-32.523 32.523-32.523c17.962-.001 32.523 14.561 32.523 32.523"
      />
      <circle
        clipPath="url(#d)"
        fill="none"
        stroke="#C9E7FF"
        strokeWidth={21.28}
        strokeLinecap="round"
        strokeMiterlimit={10}
        cx={577.911}
        cy={855.8}
        r={32.523}
      />
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M413.424 636.746c-4.614 3.631-28.647 22.545-28.719 53.991-.055 24.353 14.278 47.136 36.76 59.736.457 38.433 26.141 68.537 56.289 72.371 24.34 3.096 52.715-10.788 59.736-31.017 6.99-20.14-12.601-30.974-6.893-56.289 5.604-24.854 27.583-28.133 29.869-48.248 1.26-11.092-3.422-27.707-32.167-50.545-9.578-5.646-29.048-15.352-55.14-16.083-13.486-.376-37.95-1.06-59.735 16.084"
      />
      <path
        clipPath="url(#d)"
        fill="none"
        stroke="#C9E7FF"
        strokeWidth={17.614}
        strokeLinecap="round"
        strokeMiterlimit={10}
        d="M413.424 636.746c-4.614 3.631-28.647 22.545-28.719 53.991-.055 24.353 14.278 47.136 36.76 59.736.457 38.433 26.141 68.537 56.289 72.371 24.34 3.096 52.715-10.788 59.736-31.017 6.99-20.14-12.601-30.974-6.893-56.289 5.604-24.854 27.583-28.133 29.869-48.248 1.26-11.092-3.422-27.707-32.167-50.545-9.578-5.646-29.048-15.352-55.14-16.083-13.486-.376-37.95-1.06-59.735 16.084z"
      />
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M455.072 559.875c0 13.158-10.667 23.825-23.825 23.825-13.159 0-23.826-10.667-23.826-23.825 0-13.157 10.667-23.824 23.826-23.824 13.158 0 23.825 10.667 23.825 23.824"
      />
      <circle
        clipPath="url(#d)"
        fill="none"
        stroke="#C9E7FF"
        strokeWidth={15.589}
        strokeLinecap="round"
        strokeMiterlimit={10}
        cx={431.246}
        cy={559.875}
        r={23.825}
      />
      <path
        clipPath="url(#d)"
        fill="#6682C2"
        d="M475.924 679.824c0 16.754-13.582 30.336-30.336 30.336s-30.336-13.582-30.336-30.336 13.582-30.336 30.336-30.336 30.336 13.582 30.336 30.336M503.013 785.071c0 8.377-6.791 15.168-15.168 15.168s-15.168-6.791-15.168-15.168 6.791-15.168 15.168-15.168 15.168 6.791 15.168 15.168"
      />
      <path
        clipPath="url(#d)"
        fill="#6682C2"
        d="M491.875 768.022c0 10.604-8.595 19.198-19.198 19.198-10.602 0-19.197-8.595-19.197-19.198s8.595-19.197 19.197-19.197c10.602 0 19.198 8.595 19.198 19.197M402.368 814.804c0 9.755-7.908 17.661-17.662 17.661-9.755 0-17.662-7.906-17.662-17.661s7.907-17.662 17.662-17.662c9.753 0 17.662 7.907 17.662 17.662"
      />
      <path
        clipPath="url(#d)"
        fill="#B9B9F7"
        d="M518.225 861.237c0 9.755-7.908 17.662-17.662 17.662-9.755 0-17.662-7.907-17.662-17.662s7.907-17.662 17.662-17.662c9.754 0 17.662 7.907 17.662 17.662M318.329 721.904c0 9.756-7.908 17.662-17.662 17.662-9.755 0-17.662-7.906-17.662-17.662 0-9.754 7.907-17.661 17.662-17.661 9.753 0 17.662 7.907 17.662 17.661M627.936 320.056c-4.901 6.561-14.193 7.903-20.754 3-6.559-4.902-7.903-14.194-3-20.753 4.902-6.56 14.194-7.903 20.754-3.001 6.559 4.903 7.902 14.194 3 20.754"
      />
      <path
        clipPath="url(#d)"
        fill="#AAC0E8"
        d="M614.459 228.142c-6.952 9.301-20.127 11.206-29.428 4.255-9.302-6.952-11.207-20.128-4.255-29.429 6.952-9.301 20.127-11.206 29.429-4.254 9.301 6.951 11.206 20.126 4.254 29.428"
      />
      <path
        clipPath="url(#d)"
        fill="#B2C7EC"
        d="M607.674 357.656c0 6.246-5.064 11.31-11.311 11.31s-11.31-5.064-11.31-11.31 5.063-11.31 11.31-11.31 11.311 5.064 11.311 11.31"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M717.845 273.979c0 15.311-12.412 27.723-27.724 27.723-15.31 0-27.722-12.412-27.722-27.723 0-15.311 12.412-27.723 27.722-27.723 15.312 0 27.724 12.412 27.724 27.723M773.29 345.751c0 7.655-6.206 13.861-13.861 13.861-7.656 0-13.862-6.206-13.862-13.861s6.206-13.861 13.862-13.861c7.655 0 13.861 6.206 13.861 13.861"
      />
      <path
        clipPath="url(#d)"
        fill="#8892F7"
        d="M535.887 548.938c0 9.755-7.908 17.662-17.662 17.662-9.755 0-17.662-7.907-17.662-17.662s7.907-17.662 17.662-17.662c9.754 0 17.662 7.908 17.662 17.662"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M551.008 613.067c0 6.246-5.064 11.31-11.31 11.31s-11.31-5.063-11.31-11.31 5.064-11.31 11.31-11.31c6.245.001 11.31 5.064 11.31 11.31M514.194 588.925c0 6.245-5.064 11.31-11.31 11.31s-11.31-5.064-11.31-11.31 5.064-11.311 11.31-11.311 11.31 5.065 11.31 11.311"
      />
      <path
        clipPath="url(#d)"
        fill="#8892F7"
        d="M565.762 546.449c0 5.327-4.317 9.646-9.645 9.646-5.326 0-9.645-4.318-9.645-9.646 0-5.326 4.318-9.645 9.645-9.645 5.327.001 9.645 4.319 9.645 9.645"
      />
      <path
        clipPath="url(#d)"
        fill="#A2C0E1"
        d="M765.775 596.698c0 10.54-8.544 19.084-19.084 19.084-10.539 0-19.083-8.544-19.083-19.084s8.544-19.084 19.083-19.084c10.54 0 19.084 8.544 19.084 19.084"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M774.084 591.779c.089-.088.089-.176 0-.264 0-.176 0-.265-.088-.441-.792-3.963-2.378-7.573-4.668-10.655a25.815 25.815 0 0 0-3.522-4.053c-2.994-2.817-6.605-5.02-10.657-6.253-.439-.176-.88-.264-1.32-.439-2.29-.528-4.668-.881-7.134-.881-3.17 0-6.341.528-9.16 1.586-.439.088-.88.264-1.319.527-4.668 1.851-8.631 4.845-11.538 8.72-.44.527-.793 1.057-1.146 1.585a27.221 27.221 0 0 0-4.755 14.972v.529c0 3.522.704 6.957 1.938 10.128 2.201 5.725 6.341 10.568 11.536 13.65 1.763 1.146 3.699 2.026 5.726 2.73 2.729.881 5.636 1.409 8.719 1.409 2.994 0 5.901-.528 8.631-1.409a29.617 29.617 0 0 0 3.875-1.585c2.114-1.058 3.963-2.29 5.726-3.875a26.026 26.026 0 0 0 6.78-8.896c.089-.088.177-.088.089-.177 1.85-3.61 2.817-7.662 2.817-11.977a22.942 22.942 0 0 0-.53-4.931m-27.39 15.237c-5.637 0-10.304-4.667-10.304-10.304 0-5.638 4.667-10.305 10.304-10.305s10.304 4.667 10.304 10.305c0 5.637-4.667 10.304-10.304 10.304"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M633.705 676.716a8.8 8.8 0 0 1-7.612-4.369c-2.451-4.197-1.04-9.59 3.165-12.041l93.911-54.838a8.804 8.804 0 0 1 12.041 3.165c2.452 4.197 1.041 9.59-3.165 12.041l-93.911 54.838a8.747 8.747 0 0 1-4.429 1.204M745.265 585.238a8.811 8.811 0 0 1-8.79-8.377l-8.188-167.933c-.231-4.859 3.51-8.988 8.369-9.229 4.688-.236 8.987 3.505 9.229 8.369l8.188 167.934a8.815 8.815 0 0 1-8.368 9.228c-.148.008-.295.008-.44.008M725.027 597.735c-.843 0-1.712-.12-2.563-.378l-60.316-18.38c-4.653-1.419-7.276-6.347-5.865-10.992 1.419-4.661 6.364-7.267 10.991-5.865l60.316 18.379c4.653 1.419 7.276 6.34 5.866 10.992a8.819 8.819 0 0 1-8.429 6.244"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M732.347 586.426a8.78 8.78 0 0 1-6.201-2.555l-27.135-26.886a8.812 8.812 0 0 1-.053-12.454c3.423-3.449 8.996-3.475 12.454-.052l27.135 26.886a8.812 8.812 0 0 1 .053 12.454 8.765 8.765 0 0 1-6.253 2.607M725.036 769.62c-.456 0-.92-.034-1.394-.112-4.8-.757-8.076-5.271-7.311-10.079l21.665-136.434c.766-4.799 5.212-8.109 10.08-7.31 4.799.757 8.075 5.271 7.311 10.08l-21.665 136.433c-.687 4.334-4.429 7.422-8.686 7.422M894.214 660.827c-1.851 5.372-3.963 10.568-6.165 15.766-.881 0-1.673-.266-2.466-.617l-123.035-51.962-.177-.088c-1.232-.528-2.289-1.321-3.17-2.29-2.202-2.467-2.907-6.077-1.497-9.247l.088-.088c.88-2.114 2.554-3.787 4.579-4.58a8.496 8.496 0 0 1 5.725-.44c.176 0 .352.088.617.176.176 0 .352.088.527.177l2.555 1.056.705.353 119.953 50.729a7.153 7.153 0 0 1 1.761 1.055"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M838.471 621.215a9.67 9.67 0 0 1-1.626-.146l-65.176-12.17c-4.782-.896-7.931-5.496-7.044-10.278.895-4.772 5.436-7.878 10.277-7.044l65.176 12.17c4.782.895 7.931 5.496 7.044 10.278-.791 4.231-4.488 7.19-8.651 7.19M718.783 841.272a8.562 8.562 0 0 1-1.729-.172c-4.764-.945-7.868-5.582-6.915-10.354l6.253-31.444c.946-4.765 5.522-7.922 10.355-6.915 4.765.946 7.87 5.581 6.915 10.355l-6.252 31.443a8.804 8.804 0 0 1-8.627 7.087M759.422 588.412a8.757 8.757 0 0 1-4.791-1.419c-4.076-2.649-5.237-8.111-2.589-12.187l60.652-93.344a8.811 8.811 0 0 1 14.777 9.599l-60.652 93.343a8.816 8.816 0 0 1-7.397 4.008"
      />
      <path
        clipPath="url(#d)"
        fill="#FFF"
        d="M770.697 592.506a8.786 8.786 0 0 1-7.011-3.466c-2.949-3.87-2.21-9.401 1.66-12.342l53.987-41.154c3.896-2.955 9.4-2.194 12.342 1.659 2.95 3.871 2.21 9.401-1.66 12.343L776.029 590.7a8.752 8.752 0 0 1-5.332 1.806M829.835 473.816a8.774 8.774 0 0 1-4.292-1.122 8.805 8.805 0 0 1-3.388-11.985l8.617-15.404a8.801 8.801 0 0 1 11.99-3.385c4.249 2.374 5.762 7.741 3.389 11.985l-8.618 15.404a8.807 8.807 0 0 1-7.698 4.507M773.286 489.1a8.805 8.805 0 0 1-8.808-8.807v-22.985c0-4.864 3.939-8.808 8.808-8.808s8.807 3.944 8.807 8.808v22.985a8.804 8.804 0 0 1-8.807 8.807M589.18 689.78c-4.353 0-8.137-3.217-8.722-7.646-.637-4.825 2.752-9.254 7.568-9.891l17.331-2.296a8.772 8.772 0 0 1 9.891 7.567c.636 4.825-2.753 9.255-7.568 9.892l-17.33 2.297a9.239 9.239 0 0 1-1.17.077M639.726 605.502h-32.055a8.803 8.803 0 0 1-8.808-8.807 8.803 8.803 0 0 1 8.808-8.808h32.055a8.802 8.802 0 0 1 8.807 8.808 8.802 8.802 0 0 1-8.807 8.807M707.499 517.469c-4.464 0-8.291-3.376-8.756-7.908l-2.296-22.401c-.49-4.838 3.027-9.164 7.87-9.658 4.729-.551 9.158 3.023 9.657 7.861l2.297 22.4c.49 4.838-3.027 9.164-7.869 9.659a7.804 7.804 0 0 1-.903.047M797.694 698.975a8.815 8.815 0 0 1-7.731-4.567l-16.083-29.294c-2.341-4.266-.783-9.616 3.482-11.964 4.283-2.313 9.616-.782 11.964 3.483l16.083 29.294a8.816 8.816 0 0 1-3.482 11.964 8.873 8.873 0 0 1-4.233 1.084"
      />
    </g>
    <g clipPath="url(#b)">
      <defs>
        <path
          id="o"
          d="M360.943 169.038c-8.895 4.139-17.438 8.455-25.805 13.21 91.77-33.995 190.41-25.276 272.228 17.527 63.146 33.026 116.254 86.309 148.575 155.798 25.101 53.899 34.612 110.97 30.474 166.278a317.387 317.387 0 0 1-5.549 40.777c-.088.88-.265 1.761-.44 2.642a368.343 368.343 0 0 1-6.43 25.806c-.088.088-.088.265-.175.439 0 .088-.088.266-.088.441a245.806 245.806 0 0 1-5.021 15.5c0 .088 0 .088-.088.176a198.894 198.894 0 0 1-3.699 10.129c-.704 2.113-1.585 4.14-2.378 6.253-3.258 7.837-6.693 15.588-10.568 23.162-7.046 14.355-15.235 28.184-24.396 41.394-32.762 47.471-78.295 87.103-134.485 113.26-87.014 40.513-182.659 40.513-265.446 7.75-69.048-27.39-129.288-77.678-168.216-146.286a414.128 414.128 0 0 0 11.362 26.862c44.035 94.677 121.097 163.548 211.018 199.217 96.613 38.311 208.376 38.311 310.098-9.071 92.035-42.803 159.673-116.871 196.135-203.709 2.201-5.195 4.315-10.392 6.165-15.764 35.14-94.677 33.818-202.829-12.154-301.644-37.782-81.29-99.872-143.468-173.677-182.044-55.818-29.252-118.352-44.874-182.086-44.872-55.429.001-111.77 11.821-165.354 36.769"
        />
      </defs>
      <clipPath id="q">
        <use xlinkHref="#o" overflow="visible" />
      </clipPath>
      <defs>
        <filter
          id="p"
          filterUnits="userSpaceOnUse"
          x={159.436}
          y={132.266}
          width={769.917}
          height={795.417}
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={159.436}
        y={132.266}
        width={769.917}
        height={795.417}
        id="s"
      >
        <g filter="url(#p)">
          <radialGradient
            id="r"
            cx={0}
            cy={1080}
            r={1}
            gradientTransform="matrix(386.0829 0 0 -386.0829 539.008 417494.25)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#4d4d4d",
              }}
            />
            <stop
              offset={0.195}
              style={{
                stopColor: "gray",
              }}
            />
            <stop
              offset={0.618}
              style={{
                stopColor: "gray",
              }}
            />
            <stop
              offset={1}
              style={{
                stopColor: "#4d4d4d",
              }}
            />
          </radialGradient>
          <path
            clipPath="url(#q)"
            fill="url(#r)"
            d="M159.436 132.266h769.917v795.417H159.436z"
          />
        </g>
      </mask>
      <radialGradient
        id="t"
        cx={0}
        cy={1080}
        r={1}
        gradientTransform="matrix(386.0829 0 0 -386.0829 539.008 417494.25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#181d88",
          }}
        />
        <stop
          offset={0.195}
          style={{
            stopColor: "#181d8d",
          }}
        />
        <stop
          offset={0.618}
          style={{
            stopColor: "#181d8d",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#181d8d",
          }}
        />
      </radialGradient>
      <path
        clipPath="url(#q)"
        mask="url(#s)"
        fill="url(#t)"
        d="M159.436 132.266h769.917v795.417H159.436z"
      />
    </g>
    <g clipPath="url(#b)">
      <defs>
        <path id="u" d="M0 0h1080v1080H0z" />
      </defs>
      <clipPath id="v">
        <use xlinkHref="#u" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#v)"
        fill="#ADBFEA"
        d="M265.235 596.698c0 22.522-18.258 40.78-40.781 40.78-22.522 0-40.781-18.258-40.781-40.78 0-22.523 18.259-40.781 40.781-40.781 22.523 0 40.781 18.258 40.781 40.781"
      />
      <path
        clipPath="url(#v)"
        fill="#ADBFEA"
        d="M232.748 544.485c0 11.261-9.129 20.39-20.39 20.39-11.262 0-20.391-9.129-20.391-20.39 0-11.261 9.129-20.39 20.391-20.39 11.261 0 20.39 9.129 20.39 20.39"
      />
      <path
        clipPath="url(#v)"
        fill="#8892F7"
        d="M300.667 596.698c0 9.754-7.908 17.662-17.662 17.662-9.755 0-17.662-7.908-17.662-17.662 0-9.755 7.907-17.662 17.662-17.662 9.753 0 17.662 7.907 17.662 17.662"
      />
      <path
        clipPath="url(#v)"
        fill="#8892F7"
        d="M314.344 594.77c0 6.38-5.172 11.551-11.551 11.551-6.38 0-11.552-5.171-11.552-11.551 0-6.381 5.172-11.552 11.552-11.552 6.379 0 11.551 5.171 11.551 11.552M349.74 671.356c0 12.171-9.867 22.038-22.038 22.038s-22.037-9.867-22.037-22.038 9.866-22.038 22.037-22.038c12.172 0 22.038 9.868 22.038 22.038"
      />
      <path
        clipPath="url(#v)"
        fill="#FFF"
        d="M373.952 554.802c0 9.089-7.368 16.457-16.457 16.457-9.09 0-16.458-7.368-16.458-16.457s7.368-16.458 16.458-16.458c9.089-.001 16.457 7.369 16.457 16.458M271.979 546.64c0 6.045-4.9 10.944-10.945 10.944s-10.945-4.899-10.945-10.944 4.9-10.945 10.945-10.945 10.945 4.9 10.945 10.945"
      />
    </g>
  </svg>
)

export default Moon